import { createUrlStore } from "../base";

export default createUrlStore()
